// Must match anything @ anything . anything
export const EmailPattern = '.+@.+\\..+';

// Must include a number, lowercase letter and special letter, minimum 14 chars
export const PasswordPattern =
  '(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\\W)(?!.* ).{14,}';

// Must be six digits
export const CodePattern = '\\d{6}';
